import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./Navbar.css";
import brandLogo from "../pages/Home/assets/sankrashan_logo.jpeg";
import { FiSend, FiX } from "react-icons/fi";

const Navbar = () => {
  const whatsappLink =
    "https://wa.me/918800418585?text=Hello%20Shankarshan%20Team%2C%20I%20need%20help%20with%20your%20services.";

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isServicesOpen, setIsServicesOpen] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const openPopup = () => setIsPopupOpen(true);
  const closePopup = () => {
    setIsPopupOpen(false);
    setIsSubmitted(false);
  };

  const handlePopupSubmit = (event) => {
    event.preventDefault();
    setIsSubmitted(true);
    event.target.reset();
    setTimeout(() => {
      setIsSubmitted(false);
      setIsPopupOpen(false);
    }, 2500);
  };

  return (
    <>
      <header className="main-header">
        <div className="container header-inner">
          <Link to="/" className="brand-logo">
            <img
              src={brandLogo}
              alt="Shankarshan Technologies Logo"
              className="logo-img"
            />
          </Link>

          <button
            className="mobile-toggle"
            onClick={() => setIsMenuOpen((prev) => !prev)}
            aria-label="Toggle menu"
          >
            ☰
          </button>

          <nav className={`main-nav ${isMenuOpen ? "open" : ""}`}>
            <Link to="/" onClick={() => setIsMenuOpen(false)}>
              Home
            </Link>
            <Link to="/about" onClick={() => setIsMenuOpen(false)}>
              About Us
            </Link>

            <div className="nav-dropdown">
              <button
                className="dropdown-btn"
                onClick={() => setIsServicesOpen(!isServicesOpen)}
                onMouseEnter={() =>
                  window.innerWidth >= 920 && setIsServicesOpen(true)
                }
              >
                Services <span className="arrow">▼</span>
              </button>
              {isServicesOpen && (
                <div
                  className="dropdown-menu"
                  onMouseLeave={() =>
                    window.innerWidth >= 920 && setIsServicesOpen(false)
                  }
                >
                  <Link
                    to="/services/sms"
                    onClick={() => {
                      setIsServicesOpen(false);
                      setIsMenuOpen(false);
                    }}
                  >
                    SMS Solutions
                  </Link>
                  <Link
                    to="/services/voice"
                    onClick={() => {
                      setIsServicesOpen(false);
                      setIsMenuOpen(false);
                    }}
                  >
                    Voice Solutions
                  </Link>
                  <Link
                    to="/services/ivr"
                    onClick={() => {
                      setIsServicesOpen(false);
                      setIsMenuOpen(false);
                    }}
                  >
                    IVR Solutions
                  </Link>
                  <Link
                    to="/services/WhatsAppApi"
                    onClick={() => {
                      setIsServicesOpen(false);
                      setIsMenuOpen(false);
                    }}
                  >
                   WhatsApp API & chatbot
                  </Link>
                  <Link
                    to="/services/missed-call"
                    onClick={() => {
                      setIsServicesOpen(false);
                      setIsMenuOpen(false);
                    }}
                  >
                    Missed Call Service
                  </Link>
                  <Link
                    to="/services/stockbroker"
                    onClick={() => {
                      setIsServicesOpen(false);
                      setIsMenuOpen(false);
                    }}
                  >
                    Stockbroker Software
                  </Link>
                </div>
              )}
            </div>

            <Link to="/contact" onClick={() => setIsMenuOpen(false)}>
              Contact Us
            </Link>

            <div className="header-cta-buttons mobile-cta">
              <a
                href={whatsappLink}
                target="_blank"
                rel="noopener noreferrer"
                className="header-cta try-demo-btn"
                onClick={() => setIsMenuOpen(false)}
              >
                Let's Chat
              </a>
            </div>
          </nav>

          <div className="header-cta-buttons desktop-cta">
            <a
              href={whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="header-cta try-demo-btn"
              onClick={() => setIsMenuOpen(false)}
            >
              Let's Chat
            </a>
          </div>
        </div>
      </header>

      {isPopupOpen && (
        <div className="nav-popup-overlay" onClick={closePopup} role="presentation">
          <div
            className="nav-popup-card"
            onClick={(event) => event.stopPropagation()}
            role="dialog"
            aria-modal="true"
            aria-label="Quick inquiry form"
          >
            <button className="nav-popup-close" onClick={closePopup} type="button" aria-label="Close popup">
              <FiX />
            </button>

            <div className="nav-popup-head">
              <p className="nav-popup-label">Quick Inquiry</p>
              <h3>Talk to our team</h3>
              <p>Share your requirement and we will reach out shortly.</p>
            </div>

            <form className="nav-popup-form" onSubmit={handlePopupSubmit}>
              <div className="nav-popup-row">
                <label htmlFor="popup-name">Full Name</label>
                <input id="popup-name" name="name" type="text" placeholder="Your full name" required />
              </div>

              <div className="nav-popup-row nav-popup-two-col">
                <div>
                  <label htmlFor="popup-email">Email</label>
                  <input id="popup-email" name="email" type="email" placeholder="name@company.com" required />
                </div>
                <div>
                  <label htmlFor="popup-phone">Phone</label>
                  <input id="popup-phone" name="phone" type="tel" placeholder="+91" required />
                </div>
              </div>

              <div className="nav-popup-row">
                <label htmlFor="popup-subject">Subject</label>
                <input id="popup-subject" name="subject" type="text" placeholder="How can we help?" required />
              </div>

              <div className="nav-popup-row">
                <label htmlFor="popup-message">Message</label>
                <textarea
                  id="popup-message"
                  name="message"
                  rows="5"
                  placeholder="Tell us about your requirement"
                  required
                />
              </div>

              <button type="submit" className="header-cta try-demo-btn nav-popup-submit">
                <FiSend />
                Submit Inquiry
              </button>

              {isSubmitted && (
                <p className="nav-popup-success">Thank you. Our team will contact you soon.</p>
              )}
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default Navbar;
